const React = require( 'react' );
import PropTypes from 'prop-types';
const classNames = require( 'classnames' );

require( './loading-overlay.less' );

const LoadingOverlay = ( props ) => {

    const classes = classNames( {
        'loading-overlay': true,
        'active': props.loading
    } );

    return (
        <div className={ props.className ? props.className : classes }>
            <div className={ props.className ? props.className : 'loading-indicator' }>
                <div className="loader primary-border"></div>
            </div>
        </div>
    );
};

export default LoadingOverlay;

LoadingOverlay.propTypes = {
    loading: PropTypes.bool
};